// telemetria.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ViagemTelemetriaDTO {
  numeroVeiculo: number;
  horaInicioServico: string;
  horaFimServico: string;
  intervalo: string;
  kmRodado: number;
}

export interface LocalizacaoVeiculo {
  latitude: number;
  longitude: number;
}

@Injectable({
  providedIn: 'root'
})
export class TelemetriaService {

  constructor(private http: HttpClient) { }

  listarViagensPorMatriculaEData(matricula: number, dataOperacao: string): Observable<ViagemTelemetriaDTO[]> {
    let params = new HttpParams()
      .set('matricula', matricula.toString())
      .set('dataOperacao', dataOperacao);

    return this.http.get<ViagemTelemetriaDTO[]>(`/telemetria/viagens`, { params });
  }

  obterLocalizacaoVeiculo(numeroVeiculo: number): Observable<LocalizacaoVeiculo> {
    return this.http.get<LocalizacaoVeiculo>(
      `/telemetria/localizacao/${numeroVeiculo}`
    );
  }
}